module.exports = __webpack_public_path__ + "static/media/macohattori.f5d061e4.gif";